<template>
  <q-dialog
    v-model="optionCallback.show"
    persistent
  >
    <q-card style="min-width: 320px; max-width: 400px;">
      <q-card-section class="bg-section text-h6 text-center q-pa-sm">
        Deseja retornar a chamada?
      </q-card-section>

      <q-separator />

      <q-card-section class=" q-pa-md">
        <div class="row justify-around items-center q-gutter-sm">
          <div
            class="text-subtitle2 text-grey-8"
            :class="{ 'no-select': isAnonymizationEnabled }"
          >
            <q-icon
              name="mdi-account"
              class="q-mr-xs"
            />
            <q-tooltip v-if="isAnonymizationEnabled">
              Número anonimizado
            </q-tooltip>
            {{ contact }}
          </div>
          <div class="text-subtitle2 text-grey-8">
            <q-icon
              name="mdi-timer-outline"
              class="q-mr-xs"
            /> {{ timer || 0 }}s
          </div>
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions class="justify-between ">
        <q-btn
          data-testid="retorno-fechar"
          flat
          dense
          color="grey-7"
          label="Fechar"
          v-close-popup
          @click="handleOptionCallback(false)"
        />
        <q-btn
          data-testid="retorno-confirmar"
          unelevated
          color="green"
          dense
          label="Retornar"
          icon="mdi-phone"
          @click="handleOptionCallback(true)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { formatPhone, anonymizePhone } from '@/components/utils/phones'

export default {
  data () {
    return {
      timer: null,
      showDialog: true
    }
  },

  computed: {
    ...mapGetters({
      hasSchedulePause: 'agentModule/hasSchedulePause',
      hasScheduleLogout: 'agentModule/hasScheduleLogout',
      optionCallback: 'attendanceModule/optionCallback',
      queueProperties: 'agentModule/queueProperties'
    }),

    isAnonymizationEnabled () {
      if (!this.optionCallback?.queue) return false
      return this.queueProperties(this.optionCallback.queue)?.anonymizePhone === 'yes'
    },

    contact () {
      const phone = this.optionCallback.contact
      if (!phone) return ''

      if (this.isAnonymizationEnabled) {
        return anonymizePhone(phone)
      }

      return formatPhone(phone)
    }
  },

  methods: {
    ...mapActions({
      call: 'sipModule/call',
      pause: 'sipModule/pause',
      logout: 'sipModule/logout',
      updateOptionCallback: 'attendanceModule/updateOptionCallback'
    }),

    startCountTimer () {
      const vm = this
      vm.timer = vm.optionCallback.timer
      const countdown = setInterval(() => {
        vm.timer--

        if (vm.timer <= 0) {
          clearInterval(countdown)
          this.resetOptionCallback()
          vm.hasScheduleAction()
        }
      }, 1000)
    },

    async handleOptionCallback (isAccepted) {
      const vm = this
      isAccepted ? await vm.call([vm.optionCallback.contact, vm.optionCallback.queue]) : vm.hasScheduleAction()
      this.resetOptionCallback()
    },

    resetOptionCallback () {
      const vm = this
      vm.timer = null
      vm.pendingAccept = false

      const optionCallback = { ...vm.optionCallback }
      optionCallback.show = false
      optionCallback.timer = 0

      this.updateOptionCallback(optionCallback)
    },

    hasScheduleAction () {
      const vm = this
      if (vm.hasScheduleLogout) vm.logout()
      if (vm.hasSchedulePause) vm.pause(vm.hasSchedulePause)
    }
  },

  watch: {
    optionCallback: {
      handler (newValue) {
        if (newValue.show && newValue.timer > 0) return this.startCountTimer()
        this.timer = null
      }
    }
  }
}
</script>
<style lang="sass" scoped >
.bg-section
  background-color: #E3F2FD
  color: #3D4A51

.info
  background-color: #F0F8FD

.no-select
  user-select: none
  -webkit-user-select: none
  -moz-user-select: none
  -ms-user-select: none
</style>
